// @ts-strict-ignore
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewContainerRef, OnDestroy } from '@angular/core';

import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMModel, LMModelChangedEvent } from './model/lm-model';
import { SubscriptionLike as ISubscription } from 'rxjs';

export class LMInstanceCountChartEvent implements LMFieldEvent {
  layoutObject: LMChartField;
  event: Event;
  eventType: LMFieldEventType;

  constructor(event: Event, layoutObject: LMChartField) {
    this.eventType = 'InstanceCountChartEvent';
    this.event = event;
    this.layoutObject = layoutObject;
  }
}

@Component({
  selector:    'lm-form-content-instancechart',
  providers:   [],
  templateUrl: 'lm-form-content-instance-count.component.html',
  styleUrls:   [ 'lm-form-content-instance-count.component.scss' ]
})

export class LMFormContentInstanceCountComponent implements AfterViewInit, OnInit, OnDestroy {

  @Input() formSpec: LMFormSpec = null;
  @Input() formOptions: LMFormOptions = null;

  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() model: LMModel;
  @Input() formState: LMFormState;
  @Input() chartFields: Array<LMChartField>;
  @Input() set fromDataView(dataView: LMDataView) {
    this._fromDataView = dataView;
    this.build();
  }
  @Input() placeHolder: ViewContainerRef;
  @Input() formPersonalization: LMFormPersonalization;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  public instanceCountFields: Array<LMInstanceChartSpec>;

  private subscriptionArray: Array<ISubscription> = [];
  private _fromDataView: LMDataView;

  constructor(
    private lmLoggerService: LMLoggerService,
    private lmFormatUtilService: LMFormatUtilService
  ) {}

  ngOnInit() {
    this.build();

    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {

        if (modelChangedEvent.eventType === 'set') {
          this.build();
        }
      })
    );
  }

  ngAfterViewInit() {
    // this.lmLoggerService.log([ this, 'ngAfterViewInit', 'this.form.valid=', this.form.valid ]);
  }

  ngOnDestroy() {
    // clean up all subscriptions
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    this.subscriptionArray = [];
  }

  selectImage(event) {
    const chartFields = this.chartFields ? this.chartFields : this.formSpec.busFormSpec.chart.fields;
    const id = event.currentTarget.getAttribute('id');
    for (let i = 0, len = chartFields.length; i < len; i++) {
      const field = chartFields[ i ];
      if (field.id === id) {
        if (field.type === 'navigation') {
          this.fieldEvent.emit(new LMInstanceCountChartEvent(event, field));
        }
        break;
      }
    }
  }

  trackById(index: number, instanceCharts: LMInstanceChartSpec): string {
    return instanceCharts.id;
  }

  private build() {
    const fields: Array<LMInstanceChartSpec> = [];
    const chartFields: LMChartField[] = this.chartFields ? this.chartFields : this.formSpec.busFormSpec.chart.fields;

    chartFields.forEach((chartField: LMChartField) => {
      if (this.specFields[ chartField.id ]) {
        const specField: LMSpecField = this.specFields[ chartField.id ];

        const field = {
          id:    specField.bindId,
          value: this.lmFormatUtilService.numericToDisplay(this.model.getField(specField.bindId).getData(), { displayZero: true }),
          label: this.lmFormatUtilService.formatMessageRule(specField.label, this.model),
          link:  (specField.link) ? specField.link : '#'
        };

        fields.push(field);
      }
    });

    this.instanceCountFields = fields;
  }
}
